import {
  PropsWithChildren,
  ReactElement,
  createContext,
  useContext,
} from "react";
import { AccommodationDataAccess } from "../Data/AccommodationDataAccess";

export class ApiContextData {
  Accommodation: AccommodationDataAccess;

  constructor() {
    this.Accommodation = AccommodationDataAccess.prototype;
  }
}

interface ApiProviderProps {
  Api: ApiContextData;
}

const ApiContext = createContext<ApiContextData>(ApiContextData.prototype);

export function useApi(): ApiContextData {
  return useContext(ApiContext);
}

export function ApiProvider(
  props: PropsWithChildren<ApiProviderProps>,
): ReactElement {
  return (
    <ApiContext.Provider value={props.Api}>
      {props.children}
    </ApiContext.Provider>
  );
}
